import { version } from '../package.json'
import LuckyLottery, {
  RotateHighlight,
  RotateTurntable,
  RotatePointer,
  NineGrid,
} from './packages/lucky-lottery'
const components = [LuckyLottery]

const install = Vue => {
  if (install.installed) {
    return
  }
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export { LuckyLottery }

export default {
  version,
  install,
}

window.LuckyLotteryComponent = LuckyLottery
window.RotateHighlight = RotateHighlight
window.RotateTurntable = RotateTurntable
window.RotatePointer = RotatePointer
window.NineGrid = NineGrid
